// @flow
import has from 'lodash/has';

import { appQueryParameters } from '@clubmed/utils';

import appConfig from 'Config';

// makes inexact to allow other query params
type InexactQueryParams = $ReadOnly<{ ...GlobalQueryParams }>;

const shouldIgnoreThirdParty = <T: InexactQueryParams>(queryParams: T) => {
  return has(queryParams, appQueryParameters.noThirdParty);
};

let appLocaleConfig;

export const getConfigWithNoThirdPartySupport = <T: InexactQueryParams>({
  name,
  locale,
  queryParams,
}: {
  name: string,
  locale: $PropertyType<AppContext, 'locale'>,
  queryParams: T,
}) => {
  // cache if on browser
  if (!appLocaleConfig || typeof window === 'undefined') {
    appLocaleConfig = appConfig.locale(locale);
  }

  const originalConfig = appLocaleConfig.get(name);

  return shouldIgnoreThirdParty(queryParams)
    ? { ...originalConfig, enabled: false }
    : originalConfig;
};
